<template>
<div>
    <v-form>
        <v-flex xs12 sm12 md12 pa-1>

            <v-layout row="" wrap="">
                <v-flex pa-1 xs12 sm12 md6>
                    <v-card class="white--text">
                        <v-card flat="" style="min-height:370px">
                            <v-card-actions>

                                <v-layout justify-space-between column>
                                    <v-textarea auto-grow outline v-model="val.NotlarBilgileri.Aciklama1" :label="$t('Flying-Persons')">
                                    </v-textarea>
                                    <v-textarea auto-grow outline v-model="val.NotlarBilgileri.Aciklama2" :label="$t('Descriptions')+'/'+ $t('Notes')">
                                    </v-textarea>
                                </v-layout>

                            </v-card-actions>
                        </v-card>
                    </v-card>
                </v-flex>
                <v-flex pa-1 xs12 sm12 md6>
                    <v-card class="white--text" >
                        <v-card flat="" style="min-height:370px">
                            <v-card-actions>
                                <v-layout justify-space-between column>
                                    <v-textarea rows="15" readonly outline v-model="val.NotlarBilgileri.AirlineFile" label="Airline File">
                                    </v-textarea>
                                </v-layout>
                            </v-card-actions>
                        </v-card>
                    </v-card>
                </v-flex>
            </v-layout>

        </v-flex>

        <v-layout row="" wrap="">
            <v-flex xs12 sm12 md12>
                <v-card flat="" color="#9E9E9E">
                    <v-card-title>
                        <span class="subheading white--text font-weight-medium ">{{$t('Segments')}}</span>
                    </v-card-title>
                </v-card>

            </v-flex>
        </v-layout>

        <v-layout row wrap>

            <v-flex xs12 sm6 md6 pa-1>
                <v-card class="white--text">
                    <v-card flat="">
                        <v-card-actions>
                            <v-layout justify-space-between column>
                                <v-text-field hide-details="" v-model="val.NotlarBilgileri.Segment1" label="Segment-1"></v-text-field>
                                <v-text-field hide-details="" v-model="val.NotlarBilgileri.Segment2" label="Segment-2"></v-text-field>
                                <v-text-field hide-details="" v-model="val.NotlarBilgileri.Segment3" label="Segment-3"></v-text-field>
                                <v-text-field hide-details="" label="Segment-4" v-model="val.NotlarBilgileri.Segment4"></v-text-field>
                                <v-text-field hide-details="" label="Segment-5" v-model="val.NotlarBilgileri.Segment5"></v-text-field>
                                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Alternative-Amount')+'1'" v-model="val.NotlarBilgileri.AlternatifTutar1" :autocomplete="'autocomplete'"></parainput>
                                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Alternative-Amount')+'2'" v-model="val.NotlarBilgileri.AlternatifTutar2" :autocomplete="'autocomplete'"></parainput>
                                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Alternative-Amount')+'3'" v-model="val.NotlarBilgileri.AlternatifTutar3" :autocomplete="'autocomplete'"></parainput>

                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-flex>

            <v-flex xs12 sm6 md6 pa-1 pb-4>
                <v-card class="white--text">
                    <v-card flat="">
                        <v-card-actions>
                            <v-layout justify-space-between column>

                                <v-text-field hide-details="" v-model="val.NotlarBilgileri.RealCode" :label="$t('Realised-Code')">
                                </v-text-field>
                                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Ref-Fare')" v-model="val.NotlarBilgileri.RefFare" :autocomplete="'autocomplete'"></parainput>

                                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Lowest-Fare')" v-model="val.NotlarBilgileri.LowFare" :autocomplete="'autocomplete'"></parainput>

                                <tarihim :etiket="$t('Reservation-Date')" v-bind:value="val.NotlarBilgileri.DateofRes" v-model="val.NotlarBilgileri.DateofRes"></tarihim>
                                <v-text-field hide-details="" disabled="" v-model="val.NotlarBilgileri.RezervasyonID" label="RES ID">
                                </v-text-field>
                                <v-text-field hide-details=""  v-model="val.DigerBilgileri.SiparisID" label="SİP ID">
                                </v-text-field>
                                <v-text-field hide-details="" mask="################" v-model="val.NotlarBilgileri.KarbonSalinimi" :label="$t('Carbon-Emission')"></v-text-field>
                                <v-checkbox :label="$t('Contracted')" v-model="val.NotlarBilgileri.Anlasmali" hide-details=""></v-checkbox>
                                <v-checkbox :label="$t('Flexible-Ticket')" v-model="val.NotlarBilgileri.Esnek" hide-details=""></v-checkbox>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-flex>

        </v-layout>

    </v-form>
</div>
</template>

<script>
import parainput from '@/components/app/customcomp/parainput.vue'
import tarihim from '../../customcomp/tarihim'
import helpers from "@/components/app/customcomp/helpers.js"

export default {
    props: ["value"],
    components: {
        parainput,
        tarihim

    },
    computed: {
        val: {
            get: function () {

                return this.value;
            },
            set: function (newValue) {
                this.$emit('input', newValue)
            },
        },
    },

    data() {
        return {

        }
    },

    methods: {
        getparabirimi() {
            return helpers.getparabirimi()
        }

    },

}
</script>
